// Native controls remain available when autoplay is blocked or motion is paused.
if (!customElements.get('hero-video')) {
  customElements.define('hero-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotion = () => {
        this.video.autoplay = !this.motion.matches;
        if (this.motion.matches) this.video.pause();
      };
      this.motion.addEventListener('change', this.onMotion);
      this.onMotion();
    }
    disconnectedCallback() {
      this.motion?.removeEventListener('change', this.onMotion);
      this.video?.pause();
    }
  });
}
